import { tail } from 'lodash';
import { isEmpty } from 'ramda';
import { CreateSponsorFormData } from '~admin/view/components/details/sponsor-details/create-sponsor.component';
import { SponsorCreateRequest } from '~client/model/admin/sponsor-create-request';
import { SponsorTranslationRequestItem } from '~client/model/admin/sponsor-translation-request-item';

/**
 * Transforms CreateSponsorFormData to SponsorCreateRequest
 * @param values
 */
export const getCreateSponsorRequest = (values: CreateSponsorFormData): SponsorCreateRequest => {
  const { sponsorMedia, url } = values;
  let translations: SponsorTranslationRequestItem[] = null;
  const trimmedUrl = tail(url);

  if (!isEmpty(trimmedUrl)) {
    translations = trimmedUrl.map(({ value, language }) => ({
      url: value,
      locale: language,
    }));
  }

  return {
    iconMediaId: sponsorMedia.id,
    url: url[0].value,
    translations,
  };
};



// WEBPACK FOOTER //
// ./view/components/details/sponsor-details/helper/create-sponsor-request.helper.ts